export default "__VITE_ASSET__D3ao2j7P__"